import { HazardViewCount } from '../entities'

export interface PaletteOptions {
    '50': string
    '100': string
    '200': string
    '300': string
    '400': string
    '500': string
    '600': string
    '700': string
    '800': string
    '900': string
}

export const colors = {
    primary: {
        CERULEAN: '#05446A',
        CORAL: '#FF414D',
        HELIOTROPE: '#B844AC',
        WAIKATO: '#04B800',
        BLUEBERRY: '#5777FF',
    },
    secondary: {
        BONDI: '#0B98A9',
        PANACHE: '#F1FAEE',
        JELLYBEAN: '#477896',
        YELLOW: '#FFFF00',
        LINKY: '#0000FF',
        NAPLES: '#F9DC5C',
        GREENSHEEN: '#60BC97',
        CETACEAN: '#000057',
        VIRIDIAN: '#0195A1',
        HEAT_WAVE: '#FF7A00',
    },
    grays: {
        NOIR: '#202020',
        CHARCOAL: '#333333',
        THUNDERCLOUD: '#575757',
        NIMBUS: '#787878',
        CUMULUS: '#999999',
        SILVER: '#C7C7C7',
        SILK: '#E5E5E5',
        SMOOTH: '#EEEEEE',
        WHITESMOKE: '#F6F6F6',
        BLANC: '#FFFFFF',
    },
    softTones: {
        CERULEAN: '#9BB4C3',
        CORAL: '#FFB3B8',
        HELIOTROPE: '#E3B4DF',
        WAIKATO: '#9BE399',
        BLUEBERRY: '#BCC9FF',
    },
    chips: {
        /** Hazard filters */
        DODGER: '#2398F9',
        ORCHID: '#D94CDC',
        HOTPINK: '#FF72A4',
        CARIBBEANGREEN: '#00C2AB',
        RUSSETT: '#7B5E59',
        LIGHTSEA: '#20BACB',
        SALMON: '#EB9481',
        VIOLET: '#610063',
        SEAGREEN: '#269753',
        /** Content boosters / CSO filters */
        PEROLOUS: '#2C87D3',
        INDIGO: '#6900AA',
        MINT: '#39BB82',
        NEWYORK: '#D7776A',
        FALU: '#782E16',
        MOSQUE: '#005E52',
        PALEVIOLET: '#C582FF',
    },
}

const basePalette: { [key: string]: PaletteOptions } = {
    primary: {
        '50': '#10a4ff',
        '100': '#008fe8',
        '200': '#0376bd',
        '300': '#075c91',
        '400': '#05446a',
        '500': '#073552',
        '600': '#07273a',
        '700': '#061824',
        '800': '#030a0f',
        '900': '#010304',
    },
    secondary: {
        '50': '#f6f6f6',
        '100': '#eeeeee',
        '200': '#e5e5e5',
        '300': '#c7c7c7',
        '400': '#999999',
        '500': '#787878',
        '600': '#575757',
        '700': '#333333',
        '800': '#202020',
        '900': '#202020',
    },
    tertiary: {
        '50': '#edace6',
        '100': '#e190d9',
        '200': '#d476ca',
        '300': '#c45eb9',
        '400': '#b844ac',
        '500': '#9e4495',
        '600': '#884381',
        '700': '#73416e',
        '800': '#5f3d5c',
        '900': '#4d384b',
    },
    error: {
        '50': '#ffe1e3',
        '100': '#ffbabe',
        '200': '#ff9299',
        '300': '#ff6a74',
        '400': '#ff414d',
        '500': '#f9313e',
        '600': '#f1212f',
        '700': '#e41724',
        '800': '#c81b27',
        '900': '#ad1f28',
    },
    success: {
        '50': '#5bff58',
        '100': '#33ff30',
        '200': '#0cff08',
        '300': '#04df00',
        '400': '#04b800',
        '500': '#079b05',
        '600': '#0a8008',
        '700': '#0c670a',
        '800': '#0c4f0b',
        '900': '#0b380a',
    },
    warning: {
        '50': '#ffcd9f',
        '100': '#ffb977',
        '200': '#ffa450',
        '300': '#ff9028',
        '400': '#ff7a00',
        '500': '#e17007',
        '600': '#c3650c',
        '700': '#a85a11',
        '800': '#8e4e13',
        '900': '#754315',
    },
    info: {
        '50': '#e4eaff',
        '100': '#e4eaff',
        '200': '#e4eaff',
        '300': '#e4eaff',
        '400': '#bcc9ff',
        '500': '#a8b9fc',
        '600': '#94a8f8',
        '700': '#8299f3',
        '800': '#728aec',
        '900': '#637ce3',
    },
    dark: {
        '50': '#202020',
        '100': '#202020',
        '200': '#333333',
        '300': '#575757',
        '400': '#787878',
        '500': '#999999',
        '600': '#c7c7c7',
        '700': '#e5e5e5',
        '800': '#eeeeee',
        '900': '#f6f6f6',
    },
}

export const palette: { [key: string]: PaletteOptions } = {
    ...basePalette,
    danger: basePalette['error'],
    muted: basePalette['secondary'],
    light: basePalette['secondary'],
    warmGray: basePalette['secondary'],
    trueGray: basePalette['secondary'],
    gray: basePalette['secondary'],
    coolGray: basePalette['secondary'],
}

export const backupHazards: HazardViewCount[] = [
    {
        hazard_id: 58,
        view_count: 3,
    },
    {
        hazard_id: 42,
        view_count: 2,
    },
    {
        hazard_id: 21,
        view_count: 1,
    },
]
